import { Label } from 'twyne-new.ui'

import InfoTip from '@Components/InfoTip'

const COLLECTION_METRIC_TIPS = {
  impression: {
    rpi: 'Revenue per Impression. f(x) = revenue / page impressions',
    rps: 'Revenue per Path Session. f(x) = revenue / unique path sessions',
    rpu: 'Revenue per Unique User. f(x) = revenue / unique users',
    rpus: 'Revenue per Unique User Session. f(x) = revenue / unique user sessions',
  },
  session: {
    converted: 'The conversion pixel fired and cost attributed.',
    convertedTrue: 'The conversion step on the form was completed.',
    scrub: <>Total of conversion-type equal to scrub or scrub bucket. <br /> f(x) = (scrub + scrub_bucket)</>,
    scrubPC: 'f(x) = (scrub + scrub_bucket) / (scrub + scrub_bucket + converted)',
    fraudConversion: 'The conversion type is fraud.',
    fraudCheckTrue: 'The fraud verification service return fraud (bad or drop score).',
    fraudCheckFalse: 'The fraud verification service return is not fraud (good or warn score).',
    fraudNotCheck: 'The fraud verification service not handled (service disabled on allocation, site or the fraud throttle was not satisfied).',
    awaitingFraudCheck: 'The fraud verification service not handled (service enabled on allocation or site, but verification was blocked or not executed).',
    cpc: 'Cost per Conversion',
    rpc: 'Revenue per Conversion',
    cpfc: 'Cost per Form Converted',
    rpfc: 'Revenue per Form Converted',
  },
}

export function getMetricTip(collection, key) {
  return COLLECTION_METRIC_TIPS[collection]?.[key]
}

export function buildMetricHeader(collection, key, label) {
  const tip = getMetricTip(collection, key)

  if (!tip) return label

  return <Label>
    {label} <InfoTip side='bottom' color='neutral' id={`${collection}-${key}`}>{tip}</InfoTip>
  </Label>
}
